import { TFunction } from 'i18next';
import { ToggleButtonProps } from 'primereact/togglebutton';
import { IconType } from 'primereact/utils';

import AirGray from '../../../../../../../../../../../../../assets/icons/AirGray';
import AirSelected from '../../../../../../../../../../../../../assets/icons/AirSelected';
import BargeGray from '../../../../../../../../../../../../../assets/icons/BargeGray';
import BargeSelected from '../../../../../../../../../../../../../assets/icons/BargeSelected';
import ShipGray from '../../../../../../../../../../../../../assets/icons/ShipGray';
import ShipSelected from '../../../../../../../../../../../../../assets/icons/ShipSelected';
import TrainGray from '../../../../../../../../../../../../../assets/icons/TrainGray';
import TrainSelected from '../../../../../../../../../../../../../assets/icons/TrainSelected';
import TruckGray from '../../../../../../../../../../../../../assets/icons/TruckGray';
import TruckSelected from '../../../../../../../../../../../../../assets/icons/TruckSelected';
import { MainRoute } from '../../../../../../../../../../../../../shared/interfaces/IFootprint';

export const getMainRouteOptions = (
  t: TFunction,
): {
  label: string;
  value: MainRoute;
  onIcon: IconType<ToggleButtonProps>;
  offIcon: IconType<ToggleButtonProps>;
}[] => {
  return [
    {
      label: t(
        'footprintDetailsPage.sections.calculatePcfSection.transportProcessSection.inputs.mainRouteOptions.road',
      ),
      value: MainRoute.ROAD,
      onIcon: TruckSelected,
      offIcon: TruckGray,
    },
    {
      label: t(
        'footprintDetailsPage.sections.calculatePcfSection.transportProcessSection.inputs.mainRouteOptions.train',
      ),
      value: MainRoute.RAIL,
      onIcon: TrainSelected,
      offIcon: TrainGray,
    },
    {
      label: t(
        'footprintDetailsPage.sections.calculatePcfSection.transportProcessSection.inputs.mainRouteOptions.ship',
      ),
      value: MainRoute.SEA,
      onIcon: ShipSelected,
      offIcon: ShipGray,
    },
    {
      label: t(
        'footprintDetailsPage.sections.calculatePcfSection.transportProcessSection.inputs.mainRouteOptions.barge',
      ),
      value: MainRoute.INLANDWATERS,
      onIcon: BargeSelected,
      offIcon: BargeGray,
    },
    {
      label: t(
        'footprintDetailsPage.sections.calculatePcfSection.transportProcessSection.inputs.mainRouteOptions.air',
      ),
      value: MainRoute.AIR,
      onIcon: AirSelected,
      offIcon: AirGray,
    },
  ];
};

export const MainRouteTranslationKeyMap: Record<MainRoute, string> = {
  [MainRoute.ROAD]: 'road',
  [MainRoute.RAIL]: 'train',
  [MainRoute.SEA]: 'ship',
  [MainRoute.INLANDWATERS]: 'barge',
  [MainRoute.AIR]: 'air',
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const MainRouteIconMap: Record<MainRoute, (options: any) => JSX.Element> = {
  [MainRoute.ROAD]: TruckGray,
  [MainRoute.RAIL]: TrainGray,
  [MainRoute.SEA]: ShipGray,
  [MainRoute.INLANDWATERS]: BargeGray,
  [MainRoute.AIR]: AirGray,
};
